import { useParams } from 'react-router-dom'
import { useEffect, useState, lazy, Suspense } from 'react'
import PublicCourse from 'components/Course/Public'
import Layout from 'components/common/Layout'
import { MediaQuery } from 'UI'
import Seo from './Seo'
import UnfollowCoursePopUp from 'components/Course/UnfollowCoursePopUp'
const PrivateCourse = lazy(() => import('components/Course/Private'))
const ResponsiveCourse = lazy(() => import('components/Course/ResponsiveCourse'))

export default ({
  fetchCurrentCourseReviewAction,
  fetchQuizContentAction,
  getQuizHistoryAction,
  courseId,
  clearQuizAction,
  fetchCourse,
  IsAccessible,
  IsFree,
  isConnected,
  loading,
  cleanStore,
  reviewStart,
  isQuizOpen
}) => {
  const [play, setPlay] = useState(false)
  const { slug, videoSlug } = useParams()
  useEffect(() => {
    fetchCourse(slug, videoSlug)
    setPlay(!!videoSlug)
    return () => {
      cleanStore()
      clearQuizAction()
    }
  }, [slug])
  useEffect(() => {
    if (isConnected) {
      fetchCurrentCourseReviewAction(slug)
      fetchQuizContentAction(slug)
      getQuizHistoryAction(courseId)
    }
  }, [isConnected, courseId, slug])

  document.getElementsByTagName('body')[0].style.overflow = loading ? 'hidden' : 'unset'
  return (
    <>
      {loading ? null : <Seo />}
      <MediaQuery ShowOnDesktop>
        {
          (!loading && (IsAccessible || (IsFree && isConnected)))
            ? (
                play
                  ? <Suspense fallback={<div />}><PrivateCourse loading={loading} play={play} setPlay={setPlay} /></Suspense>
                  : (
                    <Layout hideSupport>
                      <Suspense fallback={<div />}><PrivateCourse loading={loading} play={play} setPlay={setPlay} /></Suspense>
                    </Layout>
                    )
              )
            : (
              <Layout>
                <PublicCourse loading={loading} />
              </Layout>
              )
        }
      </MediaQuery>
      <MediaQuery HideOnDesktop>
        <Layout marginFooter={(!loading && (IsAccessible || (IsFree && isConnected))) ? 0 : '17px 17px 180px 17px'} noFooter={isQuizOpen} hideNavbar={reviewStart || isQuizOpen}>
          <Suspense fallback={<div />}>
            <ResponsiveCourse loading={loading} />
          </Suspense>
        </Layout>
      </MediaQuery>
      <UnfollowCoursePopUp />
    </>
  )
}
